import { ReactNode } from "react";
import {
  CircularProgress,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";

export const MenuNavButton = ({
  handler,
  icon,
  text,
  isLoading,
  isDisabled,
}: {
  text: string;
  icon: ReactNode;
  handler: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}) => {
  return (
    <ListItemButton
      disabled={isDisabled}
      onClick={handler}
      sx={{
        gap: "12px",
        justifyContent: "flex-start",
        color: "#4C545B",
      }}
    >
      <ListItemIcon sx={{ minWidth: "10px" }}>
        {isLoading ? (
          <CircularProgress size={20} sx={{ color: "inherit" }} />
        ) : (
          icon
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography fontWeight={500} fontSize="14px" lineHeight="20px">
            {text}
          </Typography>
        }
      />
    </ListItemButton>
  );
};
